import LinkOpenClickPerformanceChart from './LinkOpenClickPerformanceChart';

export default LinkOpenClickPerformanceChart;
